import React from 'react';
import { TypographyProps } from '@cp/ds/src/components/typography';
import { useActivatedPromocodesFreePeriod } from '../model';
import { PromocodeLabel } from './label';

export const FreePeriodLabel = ({ children, ...props }: TypographyProps) => {
  const period = useActivatedPromocodesFreePeriod();
  if (!period) {
    return null;
  }
  return (
    <PromocodeLabel {...props}>
      {period} {children ? children : 'бесплатно'}
    </PromocodeLabel>
  );
};
